module.exports = __webpack_public_path__ + "static/img/weather-bg-6.945be53.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather/weather-bg-6.gif
// module id = WSwa
// module chunks = 1